import admins from "./admins.json";
import clients from "./clients.json";
import drivers from "./drivers.json";
import vehicles from "./vehicles.json";
import operators from "./operators.json";
import cancellationReasons from "./cancellationReasons.json";
import validators from "./validators.json";
import validatorTypes from "./validatorTypes.json";
import notConfirmedUsers from "./notConfirmedUsers.json";
import orderTypes from "./orderTypes.json";
import orders from "./orders.json";
import containers from "./containers.json";
import reports from "./reports.json";
import pricing from "./pricing.json";
import store from "./store.json";
import storeDocs from "./storeDocs.json";
import storeMap from "./storeMap.json";
import nav from "./nav.json";
import auth from "./auth.json";
import dashboard from "./dashboard.json";
import datePicker from "./datePicker.json";
import receptionPlaces from "./receptionPlaces.json";
import printing from "./printing.json";
import internalStore from "./internalStore.json";

const admin = {
    admins,
    clients,
    drivers,
    vehicles,
    operators,
    cancellationReasons,
    validators,
    validatorTypes,
    notConfirmedUsers,
    orderTypes,
    orders,
    containers,
    reports,
    pricing,
    store,
    storeDocs,
    storeMap,
    nav,
    auth,
    dashboard,
    datePicker,
    receptionPlaces,
    printing,
    internalStore,
};

export default admin;

